(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["activity-image"] && !Shopify.designMode) return;
  try {
    class ActivityImage {
    constructor() {
        if (document.querySelector('.activity-block--pic a[data-btn-to-login="true"]')) {
            this.bindClickEvent();
        }
    }
    bindClickEvent() {
        document.addEventListener('click', function (e) {
            var target = e.target && e.target.closest('.activity-block--pic a[data-btn-to-login="true"]');
            if (!target) return;

            e.preventDefault();
            e.stopPropagation();

            if (pageInfo.customerInfo?.id) {
                pushSuccessMessage(target.getAttribute('data-logged-in-msg') || 'You are already logged in.');
                return;
            }

            var wrapper = target.closest('.activity-block--pic');
            var hash = wrapper ? wrapper.getAttribute('anchor') : '';

            if (window.jackeryLoginApp && typeof window.jackeryLoginApp.modalLogin === 'function') {
                window.jackeryLoginApp.modalLogin({
                    return_url: window.location.origin + window.location.pathname + "?hash=" + hash,
                    "register_act": (target.getAttribute('data-register-tag') || '').trim()
                });
            }
        });
    }
}
(function () {
    function onReady(fn) {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', fn, { once: true });
            return;
        }
        fn();
    }
    onReady(function () {
        new ActivityImage();
    });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ga-manger"] && !Shopify.designMode) return;
  try {
    window.addEventListener('DOMContentLoaded', (event) => {
      setTimeout(() => {
        (function () {
            const gaElts = document.querySelectorAll("[data-ga-event]");
            if (gaElts.length === 0) return;
            [...gaElts].map((elt) => {
                try {
                    const evtType = elt.getAttribute("data-ga-action")
                    if (!evtType) return
                    const evtName = elt.getAttribute("data-ga-event")
                    if (!evtName) return

                    if(elt.getAttribute("ga-loaded")) return
                    !elt.getAttribute("ga-loaded") && elt.addEventListener(evtType, function (evt) {
                        if(!evt.isTrusted) return
                        const target = this
                        let url = '';
                        if (target.getAttribute("data-href")) {
                            // evt.preventDefault();
                            url = target.getAttribute("data-href");
                        }
                        let params = {}
                        const attributeNames = target.getAttributeNames();

                        attributeNames.forEach(attribute => {
                            if(attribute.indexOf("data-ga-params-") === 0) {
                                const key = attribute.replace("data-ga-params-", "")
                                params[key] = target.getAttribute(attribute) === 'null' ? null : target.getAttribute(attribute)
                            }
                        });

                        window.dataLayer.push({ event_parameters: null });
                        window.dataLayer.push({
                            event: "ga4Event",
                            event_name: evtName,
                            event_parameters: {
                                current_page: window.location.href,
                                ...params
                            }
                        });

                        elt.setAttribute("ga-loaded", true)

                        setTimeout(function() {
                            if (url) {
                                if(target.getAttribute("target") === "_blank") {
                                    window.open(url, "_blank");
                                } else {
                                    window.location.href = url
                                }
                            }
                        }, 40)
                    });
                } catch (e) {
                    console.log(
                        "Something wrong happened when setting up event handling for ga4Events."
                    );
                }
            });
        })();
      }, 20)
  });
  } catch(e) { console.error(e); }
})();

})();
